export default __webpack_public_path__ + "static/media/img4.75d8ba91.png";